export const tables = {
    AssessementOneGrpReport: [{
        name: 'TYPE',
        key: 'TYPE',
        link: '',
        sort: false,
    },
    {
        name: 'TOTAL PARTICIPANTS',
        key: 'TOTAL PARTICIPANTS',
        link: '',
        sort: false,
    },
    {
        name: 'SELF COMPLETED',
        key: 'SELF COMPLETED',
        link: '',
        sort: false,
    },
    {
        name: 'TOTAL RESPONDENTS',
        key: 'TOTAL RESPONDENTS',
        link: '',
        sort: false,
    }, {
        name: 'RESPONDENTS COMPLETED',
        key: 'RESPONDENTS COMPLETED',
        link: '',
        sort: false,
    }, {
        name: 'ASSESSMENTS SUBMITTED',
        key: 'ASSESSMENTS SUBMITTED',
        link: '',
        sort: false,
    }, {
        name: 'REMAINDER',
        key: 'REMAINDER',
        link: '',
        sort: false,
    }, {
        name: 'GROUP REPORT',
        key: 'modalOpen',
        sort: false,
        type: 'text',
        link: '/app/dashBoard/viewReport/0/Download',
        target:'_blank'
    }],
    AssessementOne: [{
        name: 'TYPE',
        key: 'TYPE',
        link: '',
        sort: false,
    },
    {
        name: 'TOTAL PARTICIPANTS',
        key: 'TOTAL PARTICIPANTS',
        link: '',
        sort: false,
    },
    {
        name: 'SELF COMPLETED',
        key: 'SELF COMPLETED',
        link: '',
        sort: false,
    },
    {
        name: 'TOTAL RESPONDENTS',
        key: 'TOTAL RESPONDENTS',
        link: '',
        sort: false,
    }, {
        name: 'RESPONDENTS COMPLETED',
        key: 'RESPONDENTS COMPLETED',
        link: '',
        sort: false,
    }, {
        name: 'ASSESSMENTS SUBMITTED',
        key: 'ASSESSMENTS SUBMITTED',
        link: '',
        sort: false,
    }, {
        name: 'REMAINDER',
        key: 'REMAINDER',
        link: '',
        sort: false,
    }],
    AssessementTwo: [{
        name: 'TYPE',
        key: 'instrument__instrument_name',
        sort: false,
        type: 'logoText',
        link: '/admin/app/assessment-summary/assessments/',
        target:'_blank',
        queryParams: {
            
        }
    },  
    {
        name: 'PARTICIPANTS',
        key: 'participant__email',
        sort: false,
        type: 'text',
        link: '',

    },
    {
        name: 'SHORT NAME',
        key: 'participant__short_name',
        sort: false,
        type: 'text',
        link: '',
    },
    {
        name: 'SELF',
        key: 'assessment_completed_count',
        sort: false,
        type: 'text',
        link: '',

    }, {
        name: 'RESPONDENTS',
        key: 'respondent_count',
        sort: false,
        type: 'text',
        link: '',

    }, {
        name: 'SUBMITTED',
        key: 'is_submited',
        sort: false,
        type: 'text',
        link: '',

    }, 
    {
        name: 'DETAILS',
        key: 'external_link',
        sort: false,
        type: 'text',
        link: '/admin/app/assessment-summary/assessments/',
        target:'_blank',
        queryParams: {

        }

    },
    {
        name: '360-DEGREE FEEDBACK REPORT',
        key: 'is_RESPONDENTS_REPORT',
        sort: false,
        type: 'logoText',
        link: ' ',

    },
    {
        name:'Report download by participant',
        key: 'download_Status',
        sort: false,
        type: 'logoText',
        link: ' ',
    }
],
    AssessementThreeGrpReport: [{
        name: 'TYPE',
        key: 'instrument__instrument_name',
        sort: false,
        type: 'text',
        link: ''
    },
    {
        name: 'TOTAL PARTICIPANTS',
        key: 'TOTAL PARTICIPANTS',
        sort: false,
        type: 'text',
        link: ''
    },
    {
        name: 'YET TO START',
        key: 'YET TO START',
        sort: false,
        type: 'text',
        link: ''
    },
    {
        name: 'IN PROGRESS',
        key: 'IN PROGRESS',
        sort: false,
        type: 'text',
        link: ''        
    },
    {
        name: 'COMPLETED',
        key: 'COMPLETED',
        sort: false,
        type: 'text',
        link: ''        
    }, {
        name: 'REMAINDER',
        key: 'REMAINDER',
        sort: false,
        type: 'text',
        link: ''        
    }, {
        name: 'GROUP REPORT',
        key: 'groupReportLink',
        sort: false,
        type: 'text',
        link: '/app/dashBoard/viewReport/0/Download',
        target:'_blank'
    }],
    AssessementThree: [{
        name: 'TYPE',
        key: 'instrument__instrument_name',
        sort: false,
        type: 'text',
        link: ''
    },
    {
        name: 'TOTAL PARTICIPANTS',
        key: 'TOTAL PARTICIPANTS',
        sort: false,
        type: 'text',
        link: ''
    },
    {
        name: 'YET TO START',
        key: 'YET TO START',
        sort: false,
        type: 'text',
        link: ''
    },
    {
        name: 'IN PROGRESS',
        key: 'IN PROGRESS',
        sort: false,
        type: 'text',
        link: ''        
    },
    {
        name: 'COMPLETED',
        key: 'COMPLETED',
        sort: false,
        type: 'text',
        link: ''        
    }, {
        name: 'REMAINDER',
        key: 'REMAINDER',
        sort: false,
        type: 'text',
        link: ''        
    }],
    AssessementFour: [{
        name: 'TYPE',
        key: 'instrument__instrument_name',
        sort: false,
        type: 'logoText',
        link: '/admin/app/assessment-summary/assessments/',
        target:'_blank',
        queryParams: {
            
        }
    },
    {
        name: 'PARTICIPANTS',
        key: 'participant__email',
        sort: false,
        type: 'text',
        link: ''
    },
    {
        name: 'SHORT NAME',
        key: 'participant__short_name',
        sort: false,
        type: 'text',
        link:''
    },
    {
        name: 'SELF',
        key: 'assessment_completed_count',
        sort: false,
        type: 'text',
        link:''
    },
    {
        name: 'SUBMITTED',
        key: 'is_submited',
        sort: false,
        type: 'text',
        link:''
    }, {
        name: 'DETAILS',
        key: 'external_link',
        sort: false,
        type: 'text',
        link: '/admin/app/assessment-summary/assessments/',
        target:'_blank',
        queryParams: {
            
        }
    }],
    SellerOrgDetails: [{
        name: 'SELLER',
        key: 'seller_name',
        sort: false,
        type: 'text',
        link: '',
    },
    {
        name: 'ORGANISATION',
        key: 'organisation_name',
        sort: false,
        type: 'text',
        link: '',

    },
    {
        name: 'BATCH',
        key: 'batch_name',
        sort: false,
        type: 'text',
        link: '',
    }],
     AssessmentOverviewForMultiRater: [{
        name: 'TYPE',
        key: 'instrument__instrument_name',
        sort: false,
        type: 'logoText',
        link: '',
    },
    {
        name: 'EMAIL',
        key: 'participant__email',
        sort: false,
        type: 'text',
        link: '',

    },
    {
        name: 'PARTICIPANT NAME',
        key: 'participant__short_name',
        sort: false,
        type: 'text',
        link: '',
    },{
        name: 'PARTICIPANT PROGRESS',
        key: 'assessment_completed_count',
        sort: false,
        type: 'text',
        link: '',
    },{
        name: 'RESPONDENT PROGRESS',
        key: 'respondent_count',
        sort: false,
        type: 'text',
        link: '',
    },{
        name: 'SUBMITTED',
        key: 'is_submited',
        sort: false,
        type: 'text',
        link: '',
    }],
    AssessmentOverviewForSingleRater: [{
        name: 'TYPE',
        key: 'instrument__instrument_name',
        sort: false,
        type: 'logoText',
        link: '',
    },
    {
        name: 'EMAIL',
        key: 'participant__email',
        sort: false,
        type: 'text',
        link: '',
    },
    {
        name: 'PARTICIPANT NAME',
        key: 'participant__short_name',
        sort: false,
        type: 'text',
        link: '',
    },{
        name: 'PARTICIPANT PROGRESS',
        key: 'assessment_completed_count',
        sort: false,
        type: 'text',
        link: '',
    },{
        name: 'SUBMITTED',
        key: 'is_submited',
        sort: false,
        type: 'text',
        link: '',
    }],
    RespondentsProgress: [
    {
        name: 'EMAIL',
        key: 'participant__email',
        sort: true,
        type: 'text',
        link: '',
    },
    {
        name: 'SHORT NAME',
        key: 'participant__email',
        sort: true,
        type: 'text',
        link: '',
    },{
        name: 'RELATION',
        key: 'participant__email',
        sort: true,
        type: 'text',
        link: '',
    },{
        name: 'PROGRESS',
        key: 'participant__email',
        sort: true,
        type: 'text',
        link: '',
    }],
}


// WEBPACK FOOTER //
// ./src/_pages/Admin/AssessmentSummary/AssessmentSummaryTableData.js